import _get from 'lodash/get';
import {
  TaskBulkSchedulingInputObject,
  TaskKindEnum,
  RecurringRuleInputObject,
} from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { FieldNames } from '../enums';
import getEarlyCompletionFields from './getEarlyCompletionFields';
import getRecurringRule from './getRecurringRule';

export default function getPreparedTaskScheduleDataFromValues(
  values: Values,
): TaskBulkSchedulingInputObject {
  const kind = _get(
    values,
    `${FieldNames.taskKind}.value`,
    TaskKindEnum.Standard,
  ) as TaskKindEnum;

  if (kind === TaskKindEnum.OnDemand) {
    return { kind };
  }

  return {
    kind,
    deadlineAt: _get(values, FieldNames.deadlineAt),
    ...getEarlyCompletionFields(values),
    recurringRule: getRecurringRule(values) as RecurringRuleInputObject,
  };
}
